import React from "react";
import { Provider } from "react-redux";
import { render } from "Utils/react-utils";

import store from "../../store";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createBrowserHistory } from "history";
import { theme } from "../../context/theme";
const history = createBrowserHistory({ window });

import Advisors from "Components/landing/advisors/Advisors";
import LearnMoreBtn from "Components/landing/advisors/LearnMoreBtn";

const initPage = async () => {
	const learnMoreBtn = document.querySelector("#learnMoreBtn");
	const target = document.querySelector("#saxonAdvisors");

	if (learnMoreBtn) {
		render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<StyledEngineProvider injectFirst>
						<LearnMoreBtn />
					</StyledEngineProvider>
				</ThemeProvider>
			</Provider>,
			learnMoreBtn,
		);
	}
	if (target) {
		render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<StyledEngineProvider injectFirst>
						<Router>
							<Routes>
								<Route path={"/saxon-advisors"} element={<Advisors />} history={history} />
							</Routes>
						</Router>
					</StyledEngineProvider>
				</ThemeProvider>
			</Provider>,
			target,
		);
	}
};

// export default initPage;
initPage();
